import { Button, Menu } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useMemo } from "react";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setEditing } from "src/redux/slices/entrySlice";
import { toggleAllCollapseable } from "src/redux/slices/generatorSlice";

interface Props {
  hamburger?: boolean;
}

const GlobalCollapseButton = ({ hamburger }: Props) => {
  const dispatch = useDispatch();
  const { sections, globalCollapseable, globalCollpaseable } = useSelector(
    state => state.generatorSlice.lbentry,
  );

  const collapseableInfo = useMemo(() => {
    const collapseableSections = sections.filter(
      section => section.collapseable,
    );
    const collapsedSections = collapseableSections.filter(
      section => section.collapsed,
    );

    return {
      hasCollapseable: collapseableSections.length > 0,
      allCollapsed:
        collapseableSections.length > 0 &&
        collapsedSections.length === collapseableSections.length,
      totalCollapseable: collapseableSections.length,
    };
  }, [sections]);

  const handleToggleAll = () => {
    dispatch(toggleAllCollapseable());
    dispatch(setEditing(true));
  };

  // Check for both correct spelling and typo in data
  const isGlobalCollapseEnabled = globalCollapseable || globalCollpaseable;

  // Only show button if globalCollapseable is enabled and there are collapseable sections
  if (!isGlobalCollapseEnabled || !collapseableInfo.hasCollapseable) {
    return null;
  }

  const buttonText = `${collapseableInfo.allCollapsed ? "Expand All" : "Collapse All"} (${collapseableInfo.totalCollapseable})`;
  const icon = collapseableInfo.allCollapsed ? (
    <IconChevronDown size={16} />
  ) : (
    <IconChevronUp size={16} />
  );

  return hamburger ? (
    <Menu.Item onClick={handleToggleAll} leftSection={icon}>
      {buttonText}
    </Menu.Item>
  ) : (
    <Button
      variant="outline"
      size="sm"
      leftSection={icon}
      onClick={handleToggleAll}>
      {buttonText}
    </Button>
  );
};

export default GlobalCollapseButton;
